var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandsStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.91,135.52,63.45,119.9V99.42s-1.05-5.25-5.79-5-6.06,3.42-6.06,5.25v27.84l20.28,23.37.26,26.27h24V144.59s1.5-4.89-6.58-13.66c-6.82-7.38-19.43-24.76-26-16.62m72.79,21.21,14.45-15.62V99.42s1.06-5.25,5.8-5,6,3.42,6,5.25v27.84l-20.27,23.37-.26,26.27h-24V144.59s-1.5-4.89,6.59-13.66c6.8-7.38,19.42-24.76,26-16.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.69,96.24,132.4,46.52m-49.71,0L132.4,96.24m-60-24.86H142.7M107.55,36.23v70.31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsStar);
export default __webpack_public_path__ + "static/media/HANDS_STAR.7d44e83c278821c20dbbf04248105f24.svg";
export { ForwardRef as ReactComponent };